import { setUserDatadogRum } from './customer-vuex-plugin';
export { default as DatadogRum } from './datadog-rum';

export default setUserDatadogRum;
